import { render, staticRenderFns } from "./SimpleCompanySearch.vue?vue&type=template&id=16a2d442&scoped=true&"
import script from "./SimpleCompanySearch.vue?vue&type=script&lang=ts&"
export * from "./SimpleCompanySearch.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleCompanySearch.vue?vue&type=style&index=0&id=16a2d442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a2d442",
  null
  
)

export default component.exports